<template>
	<div class="centerPage"
		v-loading="loading"
		element-loading-text="保存中"
		element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)">
		<el-breadcrumb separator-class="el-icon-arrow-right" class="breadCrumb">
			<el-breadcrumb-item><a href="javascript:;" @click="$router.back(-1)" class="aHref">预约管理</a>
			</el-breadcrumb-item>
			<el-breadcrumb-item>预约设置</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="formUserInfo">
			<!-- 咨询参数配置 start -->
			<div class="left">
				<p class="infoTit">咨询设置</p>
				<p class="special">在此设置用户预约单次咨询时长及价格</p>
				<el-form ref="form" :model="doctorSupplement" label-width="120px" class="info" label-suffix="：" :rules="rules">
					<el-form-item label="咨询方式">
						<el-radio-group v-model="doctorSupplement.consultMode" class="type">
							<el-radio :label="2">视频(包含语音)</el-radio>
							<el-radio :label="1">语音</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="初次咨询价格" prop="initialCharge">
						<el-input
							maxlength="8"
							oninput="value=value.replace(/[^\d.]/g,'').replace(/^()*(\d+)\.(\d\d).*$/, '$1$2.$3')"
							v-model="doctorSupplement.initialCharge"
							placeholder="请输入初次通话单价"
							clearable></el-input>
						<i class="el-input__icon">元</i>
					</el-form-item>
					<el-form-item label="再次咨询价格" prop="initialCharge">
						<el-input
							maxlength="8"
							oninput="value=value.replace(/[^\d.]/g,'').replace(/^()*(\d+)\.(\d\d).*$/, '$1$2.$3')"
							v-model="doctorSupplement.furtherCharge"
							placeholder="请输入再次通话单价"
							clearable></el-input>
						<i class="el-input__icon">元</i>
					</el-form-item>
					<el-form-item label="一次咨询时长">
						<el-select v-model="doctorSupplement.initialMinute" @change="handleInitialMinuteSelect">
							<el-option label="15分钟" :value="15"/>
							<el-option label="20分钟" :value="20"/>
							<el-option label="30分钟" :value="30"/>
							<el-option label="60分钟" :value="60"/>
						</el-select>
					</el-form-item>
					<el-form-item label="工作时区" prop="workTimezone">
						<el-select placeholder="请选择" class="timezone-select"
							filterable
							:multiple="false"
							v-model="workTimezone"
							ref="timezone">
							<el-option
								v-for="(item,index) in zoneList"
								:key="'zone_option'+index"
								:label="item"
								:value="item">
							</el-option>
						</el-select>
					</el-form-item>
          <el-form-item label="特殊说明">
              <el-input type="textarea" v-model="doctorSupplement.specialNote" :rows="3" style="width: 250px" placeholder="需要特殊说明的内容" maxlength="60" show-word-limit></el-input>
          </el-form-item>
					<el-button size="mini" class="submit" @click="save()">保存设置</el-button>
				</el-form>
			</div>
			<!-- 咨询参数配置 end -->

			<!-- 特定日期预约时间设置 start -->
			<div class="right">
				<div class="flex">
					<div class="infoTit">时间设置
						<el-row style="color: #333333;font-size: 15px;">
							<el-col :span="6"><span class="mr10 bottom-block week-set-color"></span>周设置</el-col>
							<el-col :span="6"><span class="mr10 bottom-block date-set-color"></span>特殊设置</el-col>
						</el-row>
					</div>

					<el-button class="weekSet" plain @click="weekSettingShow=true">周设置</el-button>
				</div>
				<p class="special">在日历上选择日期，对当天开放预约时间进行设置，用户可在开放时间内进行预约</p>
				<div class="setting">
					<el-calendar v-model="calendar" class="calendar">
						<template slot="dateCell" slot-scope="{date, data}">
							<p style="position: relative;" :class="data.isSelected ? 'is-selected' : ''">
								{{ data.day.split('-').slice(2).join('') }}
								<template v-if="data.type === 'current-month'">
									<template v-if="monthObj[data.day]
									&& monthObj[data.day].isOpen==1
									&& monthObj[data.day].type =='week_set' ">
										<span class="bottom bottom-block week-set-color" :title="JSON.stringify(data)"></span>
									</template><!--周设置-->
									<template v-else-if="monthObj[data.day]
									&& monthObj[data.day].isOpen==1
									&& monthObj[data.day].type =='date_set' ">
										<span class="bottom bottom-block date-set-color" :title="JSON.stringify(data)"></span>
									</template><!--特殊设置-->
									<template v-else><span class="bottom bottom-block" :title="JSON.stringify(data)"></span>
									</template><!--无预约时间-->
								</template>
							</p>
						</template>
					</el-calendar>
					<div style="float:right;">
						<div class="cur-date">{{curDate}}</div>
						<div class="box" @mousedown="handleMouseDown">
							<div class="mask" v-show="is_show_mask"
								:style="'width:'+mask_width+'left:'+mask_left+'height:'+mask_height+'top:'+mask_top">
							</div>
							<el-checkbox-group v-model="select_list" class="todat-time">
								<el-checkbox :label="item.time" v-for="(item,i) in dayTime" :key="i" class="allX">
									<p @click.stop.prevent>{{ (item.time).toString().padStart(2, '0') }}:00 ~
										{{ (item.time).toString().padStart(2, '0') }}:59</p>
								</el-checkbox>
							</el-checkbox-group>
							<el-button size="mini" class="submitYellow" @click="saveSet()">保存设置</el-button>
						</div>
					</div>
				</div>
			</div>
			<!-- 特定日期预约时间设置 end -->

			<!-- 周时间设置 start -->
			<el-drawer
				title="周时间设置" class="drawerTime"
				:visible.sync="weekSettingShow" size="600px" :close-on-press-escape="false" :wrapperClosable="false">
				<div class="timeSet">
					<div style="height: 100%">
						<div class="tipsX" style="margin-bottom: 8px;color: #567CFF;">每个格子代表1小时</div>
						<div class="lineY">
							<div v-for="(item,i) in dayTime" :key="i" class="allX">
								<el-checkbox :label="item.time" @change="checkPointAll($event,item.time,1)">
									{{ (item.time).toString().padStart(2, '0') }}:00 ~ {{ (item.time).toString().padStart(2, '0') }}:59
								</el-checkbox>
							</div>
						</div>
					</div>
					<div style="height: 100%">
						<div class="flex lineX" style="margin-bottom: 8px;">
							<div v-for="(item,i) in week" :key="i" class="allX" style="width: 50px;margin: unset">
								<el-checkbox v-model="item.check"
									@change="checkPointAll($event,item.day)">周{{ weekText[item.day] }}
								</el-checkbox>
							</div>
						</div>
						<div class="div-timeset">
							<template v-for="(item,index) in timePoints">
								<el-tooltip :key="'span'+index" :content="item.x+':00 ~ '+item.x+':59'" placement="top-start">
                          <span class="span-time-slot time-item"
														:data-x="item.x" :data-y="item.y"
														@click="checkPoint(item)"
														:class="{'active':item.checked==true}">{{ item | itemFmt }}</span>
								</el-tooltip>
							</template>
						</div>
					</div>
				</div>
				<el-button size="mini" class="submit" @click="save()">保存设置</el-button>
			</el-drawer>
			<!-- 周时间设置 end -->

			<!--  -->
			<!--			<appoint-set ref="appointSet" :appointSetMap="appointSetMap" :weekSet="weekSet"></appoint-set>-->
			<!--  -->

		</div>
	</div>
</template>

<script>
  import base from '@/api/common';
  // import AppointSet from './components/appoint-set';

  export default {
    name: "appointmentSet",
    // components: {AppointSet},
    inject: ['reload'],
    data() {
      return {
        doctorSupplement: {// 补充配置
          consultMode: 1,
          initialMinute: 15,
          initialCharge: "",
          furtherMinute: "",
          furtherCharge: "",
          perHourAppointLimit: 4,
          specialNote: ''
        },
        zoneList: [],// 时区选项，从后台获取偏移量为整数的时区id
        rules: {// 表单规则
          initialCharge: [
            {required: true, message: '请输入价格', trigger: 'blur'},
          ]
        },

        timePoints: [],// 周设置时间点List [{x:00,y:00,checked:false},{x:00,y:01,checked:false}...]
        week: [], // 周数据 0-6
        weekText: ['一', '二', '三', '四', '五', '六', '日'],// 周x list，与week搭配使用
        dayTime: [],// 时间点数据 0-23
        appointSets: [], // 具体日期设置list
        workTimezone: '',// 工作时区
        weekSettingShow: false, // 是否展示周设置弹出层

        calendar: new Date(),//日历组件初始日期
        curDate: '',// 当前选中日期 + 周几
        select_list: [],// 选中时间点list
        is_show_mask: false,//是否展示选框
        box_screen_left: 0,//时间点设置开始坐标x
        box_screen_top: 0,//时间点设置开始坐标y
        start_x: 0,//鼠标开始坐标x
        start_y: 0,//鼠标开始坐标y
        end_x: 0,//鼠标结束坐标x
        end_y: 0,//鼠标结束坐标y

        monthObj: {},// 当月对象
        curMonth: new Date().getMonth(),// 当前月int值 0~11
        loading: false,
      }
    },
    watch: {
      calendar(val, oval) {
        this.curDate = val.Format('yyyy-MM-dd') + ' ' + ['周日', '周一', '周二', '周三', '周四', '周五', '周六'][val.getDay()];
        if (val.getMonth() !== this.curMonth) {
          this.curMonth = val.getMonth();
          let timestamp = val.getTime();
          this.getData(timestamp);
        }
        if (this.monthObj[val.Format('yyyy-MM-dd')] && this.monthObj[val.Format('yyyy-MM-dd')].isOpen === 1) {
          let arr = [];
          this.monthObj[val.Format('yyyy-MM-dd')].timeSlots.split(",").map(item => {
            arr.push(parseInt(item));
          });
          this.select_list = arr;// 获取该天开放时间
        } else {
          this.select_list = [];// 置空
        }
      }
    },
    computed: {
      mask_width() {// 选框宽度
        return `${Math.abs(this.end_x - this.start_x)}px;`;
      },
      mask_height() {// 选框高度
        return `${Math.abs(this.end_y - this.start_y)}px;`;
      },
      mask_left() {// 选框左坐标x
        let box_left = 0;
        if (document.querySelector('.box')) {
          box_left = document.querySelector('.box').getBoundingClientRect().left;
        }
        return `${Math.min(this.start_x, this.end_x) - box_left}px;`;
      },
      mask_top() {// 选框左坐标y
        let box_top = 0;
        if (document.querySelector('.box')) {
          box_top = document.querySelector('.box').getBoundingClientRect().top;
        }
        return `${Math.min(this.start_y, this.end_y) - box_top}px;`;
      }
    },
    beforeMount() {
      this.curDate = new Date().Format('yyyy-MM-dd  ') + ['周日', '周一', '周二', '周三', '周四', '周五', '周六'][new Date().getDay()];
    },
    mounted() {
      // 初始化数据
      this.getData();
    },
    methods: {
      async saveSet() {
        let vm = this;
        vm.loading = true;
        let arr = vm.select_list.sort((a, b) => a - b);
        const yyyyMMdd = vm.curDate.substr(0, 10);
        const id = vm.monthObj[yyyyMMdd].id || -1;
        let item = {
          "isOpen": arr.length === 0 ? 0 : 1,
          "timeSlots": arr.length === 0 ? '' : arr.join(','),
          "setDate": yyyyMMdd,
          "setMonth": vm.calendar.getMonth() + 1,
          "setYear": vm.calendar.getFullYear(),
          "dayOfWeek": vm.calendar.getDay(),
          "year": vm.calendar.getFullYear(),
          "month": vm.calendar.getMonth(),
          "date": vm.calendar.getDate(),
        };
        if (id != -1) {
          item.id = id;
        }
        // await this.$ajax.post(base.api.doctor.saveAppointSet, {list: [item]})
        await this.$ajax.post(base.api.doctor.saveAppointSet, item)
          .then((res) => {
            if (res.data.status === 'success') {
              vm.$message.success('保存成功');
              vm.reload();
            } else{
              vm.$message.error(res.data.message);
						}
          }).catch(err=>{
            console.error(err);
            vm.$message.error('保存失败, 请稍后再试');
						}).finally(() => {
              vm.loading = false;
            });
      },
      selected(event) {
        $(event.currentTarget).toggleClass('active');
      },
      delSet(id) {
        let vm = this;
        vm.$ajax.post(base.api.doctor.delAppointSet.concat("?id=" + id))
          .then((res) => {
            if (res.data.status === 'success') {
              vm.$message.success('删除成功');
              vm.reload();
            }
          })
      },
      // 保存（咨询配置、周设置）
      async save() {
        let vm = this;
        this.$refs['form'].validate((valid) => {
          if (valid) {
            // 保存时区时，统一转换成北京时区
            const offset = vm.zoneMap[vm.workTimezone];
            let temp = '00';
            let all = [];
            let arr = [];
            $(this.timePoints).each((i, o) => {
              if (o.y == temp) {
                if (o.checked) {
                  arr.push(Number(o.x))
                }
              } else {
                temp = o.y;
                all.push(arr || '');
                arr = [];
                if (o.checked) {// 检查是否选中，否则可能漏掉x=00
                  arr.push(Number(o.x))
                }
              }
            })
            all.push(arr || '');

            // 北京时区
            temp = '00';
            let bjall = [], bjarr = [];
            $(this.timePoints).each((i, o) => {
              if (o.y == temp) {
                if (o.checked) {
                  bjarr.push(Number(o.x) + (8 - offset))
                }
              } else {
                temp = o.y;
                bjall.push(bjarr || '');
                bjarr = [];
                if (o.checked) {// 检查是否选中，否则可能漏掉x=00
                  bjarr.push(Number(o.x) + (8 - offset))
                }
              }
            });
            bjall.push(bjarr || '');

            let dayOffset = 0;
            if (offset > 8) {
              dayOffset = -1;
            } else if (offset < 8) {
              dayOffset = 1;
            }
            for (let i = 0; i < bjall.length; i++) {
              let narr = [];
              let oarr = [];
              bjall[i].map((slot) => {
                if (slot >= 24) {
                  oarr.push(slot - 24);
                } else {
                  narr.push(slot);
                }
              });
              bjall[i] = narr;
              let dayIndex = (i + dayOffset) >= 7 ? (i + dayOffset - 7) : (i + dayOffset);
              // console.log('dayIndex>>', dayIndex)
              dayIndex = dayIndex == -1 ? 6 : dayIndex;
              bjall[dayIndex] = [...oarr, ...bjall[dayIndex]];
            }

            for (let i = 0; i < bjall.length; i++) {
              let narr = [];
              let oarr = [];
              bjall[i].map((slot) => {
                if (slot < 0) {
                  oarr.push(slot + 24);
                } else {
                  narr.push(slot);
                }
              });
              bjall[i] = narr;
              if (oarr.length > 0) {
                let dayIndex = (i - 1) < 0 ? 6 : (i - 1);
                bjall[dayIndex] = [...oarr, ...bjall[dayIndex]];
              }
            }

            let appointTimeSlot = base.utils.generateAppointTimeSlot(bjall.join('#'));
            let params = {
              doctorId: vm.doctorSupplement.doctorId,
              consultMode: vm.doctorSupplement.consultMode,
              initialMinute: vm.doctorSupplement.initialMinute,
              initialCharge: vm.doctorSupplement.initialCharge,
              furtherMinute: vm.doctorSupplement.furtherMinute,
              furtherCharge: vm.doctorSupplement.furtherCharge,
              perHourAppointLimit: vm.doctorSupplement.perHourAppointLimit,
              appointSetting: bjall.join('#'),
              appointTimeSlot: appointTimeSlot,
              workTimezone: vm.workTimezone,
              workTimezoneAppointSetting: all.join('#'),
              specialNote: vm.doctorSupplement.specialNote,
            }

            vm.$ajax.post(base.api.doctor.appointSetting, params)
              .then((res) => {
                if (res.data.status === 'success') {
                  vm.$message.success('保存成功');
                  vm.reload();
                  // vm.$message({message:'保存成功',type:'success',onClose:()=>{}})
                } else {
                  vm.$message.error(res.data.message)
                }
              }).catch((err) => {
                console.log(err)
              vm.$message.error("操作异常")
            });
          } else {
            this.$message.error("请检查所填字段");
            return false;
          }
        });


      },
      // 咨询时长选中回调
      handleInitialMinuteSelect(val) {
        const map = {
          15: 4,
          20: 3,
          30: 2,
          60: 1,
        }
        this.doctorSupplement.perHourAppointLimit = map[val];
      },
      // 选中时间点
      checkPoint(item) {
        if (item) {
          item.checked = !item.checked;
        }
      },
      // 选中整行或整列
      checkPointAll(checked, index, type) {
        $(this.timePoints).each((i, o) => {
          if (type === 1) {
            if (o.x == index) {
              o.checked = checked;
            }
          } else {
            if (o.y == index) {
              o.checked = checked;
            }
          }
        })
      },
      // 数据初始化
      getData(ts) {
        let vm = this;
        if(!ts){
          ts = new Date().getTime();
        }
        vm.$ajax.get(`${base.api.doctor.appointSetting}?ts=${ts}`)
          .then((res) => {
            if (res.data.status == 'success') {
              vm.zoneList = res.data.data.zoneList;//时区选项list
              vm.zoneMap = res.data.data.zoneMap;//时区偏移量map，偏移值均为整数

              vm.doctorSupplement = res.data.data.doctorSupplement;//补充配置
              vm.workTimezone = vm.doctorSupplement.workTimezone;//已设置时区
              vm.appointSets = res.data.data.appointSets;//预约设置

              vm.monthObj = res.data.data.monthObj;

              let kdate = vm.curDate.substr(0, 10) || '';
              if (vm.monthObj[kdate] && vm.monthObj[kdate].isOpen === 1) {
                let arr = [];
                vm.monthObj[kdate].timeSlots.split(",").map(item => {
                  arr.push(parseInt(item));
                });
                vm.select_list = arr;// 获取该天开放时间
              }
              vm.draw();
            }
          })
      },
      // 渲染周设置
      draw() {
        if (this.timePoints.length === 0) {
          for (let y = 0; y < 7; y++) {
            for (let x = 0; x < 24; x++) {
              this.timePoints.push({
                x: x.toString().padStart(2, '0'),
                y: y.toString().padStart(2, '0'),
                checked: false
              });
            }
          }
        }
        if (this.week.length === 0) {
          for (let day = 0; day < 7; day++) {
            this.week.push({
              day: day,
              check: false
            })
          }
        }
        if (this.dayTime.length === 0) {
          for (let time = 0; time < 24; time++) {
            this.dayTime.push({
              time: time,
              checkTime: false
            })
          }
        }
        let vm = this;
        vm.$nextTick(() => {
          if (!vm.doctorSupplement.workTimezoneAppointSetting) {
            return;
          }
          let arr = vm.doctorSupplement.workTimezoneAppointSetting.split('#');
          for (let i = 0; i < arr.length; i++) {
            let tempArr = arr[i].split(',');
            // console.log('tempArr', tempArr)
            for (let j = 0; j < tempArr.length; j++) {
              if ($.trim(tempArr[j]).length > 0) {
                let index = Number(tempArr[j]) + 24 * i
                vm.timePoints[index].checked = true;
              }
            }
          }
        })


      },
      // 日期选中事件
      calendarOnClick(e) {
        this.select_list = []
      },
      // 特殊日期时间点选择框 鼠标按下事件
      handleMouseDown(event) {
        if (event.target.tagName === 'SPAN') return false;
        this.is_show_mask = true;
        this.start_x = event.clientX;
        this.start_y = event.clientY;
        this.end_x = event.clientX;
        this.end_y = event.clientY;
        document.body.addEventListener('mousemove', this.handleMouseMove);
        document.body.addEventListener('mouseup', this.handleMouseUp);
      },
      // 特殊日期时间点选择框 鼠标移动事件
      handleMouseMove(event) {
        this.end_x = event.clientX;
        this.end_y = event.clientY;
      },
      // 特殊日期时间点选择框 鼠标放开事件
      handleMouseUp() {
        document.body.removeEventListener('mousemove', this.handleMouseMove);
        document.body.removeEventListener('mouseup', this.handleMouseUp);
        this.is_show_mask = false;
        this.handleDomSelect();
        this.resSetXY();
      },
      // 特殊日期时间点选中事件
      handleDomSelect() {
        const dom_mask = window.document.querySelector('.mask');
        const rect_select = dom_mask.getClientRects()[0];
        const add_list = [];
        const del_list = [];
        document
          .querySelectorAll('.el-checkbox-group .el-checkbox')
          .forEach((node, index) => {
            const rects = node.getClientRects()[0];
            if (this.collide(rects, rect_select) === true) {
              if (this.select_list.includes(this.dayTime[index].time)) {
                del_list.push(this.dayTime[index].time);
              } else {
                add_list.push(this.dayTime[index].time);
              }
            }
          });
        this.select_list = this.select_list
          .concat(add_list)
          .filter((item) => !del_list.includes(item));
      },
      // 判断特殊日期时间点选项是否被框选
      collide(rect1, rect2) {
        const maxX = Math.max(rect1.x + rect1.width, rect2.x + rect2.width);
        const maxY = Math.max(
          rect1.y + rect1.height,
          rect2.y + rect2.height,
        );
        const minX = Math.min(rect1.x, rect2.x);
        const minY = Math.min(rect1.y, rect2.y);
        return maxX - minX <= rect1.width + rect2.width && maxY - minY <= rect1.height + rect2.height
      },
      // 重置鼠标所在坐标
      resSetXY() {
        this.start_x = 0;
        this.start_y = 0;
        this.end_x = 0;
        this.end_y = 0;
      }
    },
    filters: {
      itemFmt(item) {
        if (item && item.checked) {
          return item.x;
        }
        return "";
      }
    }

  }
</script>

<style lang="scss" scoped>
	@import "../../assets/css/appointmentSet.scss";

	.el-carousel__item:nth-child(2n) {
		background-color: #99a9bf;
	}

	.el-carousel__item:nth-child(2n+1) {
		background-color: #d3dce6;
	}


</style>
